export const DROPDOWN_ITEM_TYPES = Object.freeze({
  STANDARD: 'standard',
  ACCENTUATED: 'accentuated',
  DESTRUCTIVE: 'destructive',
  WARNING: 'warning',
});